import React, { FC } from 'react';
import { Box, Stack, SvgIcon, Typography } from '@mui/material';
import styles from './MentalStressComponent.module.scss';
import { WellnessItem } from '../../../services/DataFormatService';
import boddVariables from '../../../variables.module.scss';
import MentalStressIcon from '../../../assets/mentalstress.svg';
import getColourForDialGroup from '../../../services/DialGroupService';

interface MentalStressComponentProps {
    mentalStressItem: WellnessItem,
}

const MentalStressComponent: FC<MentalStressComponentProps> = (props) => {
    const { mentalStressItem } = props;
    return (
        <Box
            className={styles.MentalStressComponent}
            data-testid="MentalStressComponent"
            sx={{
                bgcolor: boddVariables.white,
                border: 2,
                borderColor: boddVariables.grey50,
                borderRadius: 1.75,
                py: 2,
            }}
        >
            <Stack alignItems="center" justifyContent="space-evenly" spacing={1}>
                <SvgIcon sx={{ width: 43, height: 43 }}><MentalStressIcon /></SvgIcon>
                <Typography sx={{
                    fontFamily: 'Poppins',
                    fontWeight: '400',
                    fontSize: '14px',
                    lineHeight: '15px',
                    color: boddVariables.black,
                    px: 3,
                    pt: 0.5,
                    minHeight: '30px',
                    textAlign: 'center',
                }}
                >
                    Mental stress index
                </Typography>
                <Stack direction="row" spacing={1}>
                    <Box sx={{
                        width: '8px',
                        height: '8px',
                        backgroundColor: getColourForDialGroup(mentalStressItem!.dialGroup!),
                        borderRadius: '50%',
                        mt: 1.25,
                    }}
                    />
                    <Typography sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '600',
                        fontSize: '14px',
                        lineHeight: '30px',
                        color: boddVariables.black,
                    }}
                    >
                        {mentalStressItem.formattedValue}
                        /5.9
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};

export default MentalStressComponent;
